import { useState, useEffect } from "react";

import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCardLink";
import MiniLoadingCard from "examples/Cards/Loading";

// React icons
import { IoDesktopSharp } from "react-icons/io5";

// Service Axios
import api from "services/api";

function MiniCardDevices() {
  const [refreshInterval, setRefreshInterval] = useState(60000);
  const [loading, setLoading] = useState(true);
  const [countComputersOffLines, setCountComputersOfflines] = useState(0);
  const [countComputersOnLines, setCountComputersOnlines] = useState(0);
  const [countAllComputers, setCountAllComputers] = useState(0);

  async function loadInfoDashAdmin() {
    setLoading(true);
    const resDevices = await api.get("devices/count?id=1");
    console.log(">>> resDevices:", resDevices.data[0]);

    const ComputersTotal = resDevices.data.count;
    const ComputersOffline = resDevices.data.devices_off;
    const ComputersOnline = (ComputersOffline / ComputersTotal) * 100;

    setCountAllComputers(ComputersTotal);
    setCountComputersOfflines(ComputersOffline);

    setCountComputersOnlines(ComputersOnline.toFixed(ComputersTotal === ComputersOffline ? 0 : 2));

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }

  useEffect(() => {
    loadInfoDashAdmin();
  }, [false]);

  useEffect(() => {
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(loadInfoDashAdmin, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  if (loading) {
    return <MiniLoadingCard />;
  } else {
    return (
      <MiniStatisticsCard
        title={{ text: "Computadores" }}
        count=""
        percentage={{
          color: countComputersOffLines > 0 ? "error" : "success",
          text:
            countComputersOffLines > 0
              ? `${countComputersOnLines}% Offline (${countComputersOffLines})`
              : `100% Online`,
        }}
        icon={{
          color: countComputersOffLines > 0 ? "error" : "success",
          component: <IoDesktopSharp size="22px" color="white" />,
        }}
        openLinkClick="/stations"
      />
    );
  }
}

export default MiniCardDevices;
